import { ErrorMessage } from "../helpers/common";
import { apiUrls } from "./apiUrls";
import { API } from "./apiUtils";


export const PostImage = async (file) => {
  try {
    const formData = new FormData();
      formData.append('image', file);
    const apiResponse = await API(apiUrls.updateimage, {}, "POST", formData);
    if (apiResponse.data.isSuccess) {
      return apiResponse.data.data;
    }
  } catch (err) {
    ErrorMessage(err?.message);
  }
};




